// Auto-generated section component extracted from Landing.jsx
import React from "react";

export default function TopSection({ api }) {
  const { Globe, handleNavClick, openMarketplace, t } = api || {};
  return (
<section id="top" className="space-y-6">
                <div className="rounded-3xl border border-slate-800/70 bg-[#010916]/85 p-6 sm:p-8">
                  <div className="inline-flex items-center gap-2 rounded-full border border-slate-700 bg-[#010916]/78 px-3 py-1 text-xs text-slate-200">
                    <span className="text-emerald-300">●</span>
                    {t.hero.tagline}
                  </div>

                  <div className="mt-5">
                    <h1 className="text-3xl sm:text-5xl font-semibold text-slate-50 leading-tight">
                      <span className="inline-flex items-center gap-1">
                        W <Globe /> W50/50
                      </span>
                      <span className="block text-emerald-300 mt-2 text-xl sm:text-2xl">
                        {t.hero.titleLine2}
                      </span>
                    </h1>
                    <p className="mt-4 text-slate-200 max-w-3xl text-sm sm:text-base">
                      {t.hero.lead}
                    </p>
                  </div>

                  <div className="mt-6 flex flex-wrap gap-3">
                    <button
                      onClick={() => handleNavClick("early-access")}
                      className="rounded-2xl border border-emerald-500/60 bg-emerald-500/10 px-4 py-2 text-sm text-emerald-300 hover:border-emerald-400"
                    >
                      {t.hero.joinCta}
                    </button>
                    <button
                      onClick={() => handleNavClick("concept")}
                      className="rounded-2xl border border-slate-700 bg-[#010916]/78 px-4 py-2 text-sm text-slate-200 hover:border-emerald-400"
                    >
                      {t.hero.learnCta}
                    </button>
                    <button
                      onClick={openMarketplace}
                      className="rounded-2xl border border-sky-500/50 bg-sky-500/10 px-4 py-2 text-sm text-sky-200 hover:border-sky-400"
                    >
                      {t.marketplace.externalCta}
                    </button>
                  </div>
                </div>
              </section>
  );
}
